import { render, staticRenderFns } from "./DashboardDataUsage.vue?vue&type=template&id=493c376f&scoped=true&"
import script from "./DashboardDataUsage.vue?vue&type=script&lang=js&"
export * from "./DashboardDataUsage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDataUsage.vue?vue&type=style&index=0&id=493c376f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493c376f",
  null
  
)

export default component.exports